import React, { ReactElement } from 'react';
import './ActivityCard.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar';
import faStarRegular from '@fortawesome/fontawesome-free-regular/faStar';
import { UserAction } from '@enview/interface/types/actions/UserAction';
import * as FileService from '../../../../services';
import TextButton from '../../Buttons/TextButton';
import { UserActionAPI } from '../../../../api';
import ReplyArrow from '../../../../components/svg/ReplyArrowIcon';

const DELETE_TEXT = 'Delete';
const DOWNLOAD_TEXT = 'Download';
const REPLY_TEXT = 'Reply';
const FAVORITE_TEXT = 'Favorite';
const UNFAVORITE_TEXT = 'Unfavorite';
const ARCHIVE_TEXT = 'Archive';
const UNARCHIVE_TEXT = 'Unarchive';

type DeleteButtonProps = {
  action: UserAction;
};

export const DeleteButton = (props: DeleteButtonProps): ReactElement => {
  const [deleteUserAction] = UserActionAPI.endpoints.deleteUserAction.useMutation();
  return (
    <TextButton
      className="activity-card-button delete destructive"
      label={DELETE_TEXT}
      onClick={() => deleteUserAction(props.action)}
    />
  );
};

type DownloadFileButtonProps = {
  fileId: string;
};

export const DownloadFileButton = (props: DownloadFileButtonProps): ReactElement => {
  return (
    <TextButton
      className="activity-card-button"
      label={DOWNLOAD_TEXT}
      onClick={() => FileService.downloadFile(props.fileId)}
    />
  );
};

type ReplyButtonProps = {
  openReplyEditor: () => void;
};

export const ReplyButton = (props: ReplyButtonProps): ReactElement => {
  const { openReplyEditor } = props;
  return (
    <button
      className="btn-text activity-card-button"
      onClick={openReplyEditor}
      type="button"
    >
      <ReplyArrow />
      <p>{REPLY_TEXT}</p>
    </button>
  );
};

type StarButtonProps = {
  action: UserAction;
};

export const StarButton = (props: StarButtonProps): ReactElement => {
  const { action } = props;
  const starIcon = action.isStarred ? faStar : faStarRegular;
  const [updateUserAction] = UserActionAPI.endpoints.updateUserAction.useMutation();

  return (
    <button
      className="btn-text activity-card-button"
      onClick={() => {
        void updateUserAction({
          newUserAction: { ...action, isStarred: !action.isStarred },
          oldUserAction: action,
        });
      }}
      type="button"
    >
      <FontAwesomeIcon
        color="#27A4CC"
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
        // @ts-ignore
        icon={starIcon}
        size="1x"
      />
      <p>{action.isStarred ? UNFAVORITE_TEXT : FAVORITE_TEXT}</p>
    </button>
  );
};

type ArchiveButtonProps = {
  action: UserAction;
};

export const ArchiveButton = (props: ArchiveButtonProps): ReactElement => {
  const { action } = props;
  const text = action.isArchived ? UNARCHIVE_TEXT : ARCHIVE_TEXT;
  const [updateUserAction] = UserActionAPI.endpoints.updateUserAction.useMutation();
  return (
    <TextButton
      className={`activity-card-button${action.isArchived ? '' : ' destructive'}`}
      label={text}
      onClick={() => {
        void updateUserAction({
          newUserAction: { ...action, isArchived: !action.isArchived },
          oldUserAction: action,
        });
      }}
    />
  );
};
